import { createStore } from 'vuex'

export default createStore({
  state: {
    count: 0,
    telNumber: '',
    countryCode: ''
  },
  getters: {
  },
  mutations: {
    dotsChange(state, payload) {
      state.count = payload
    },
    telNumberChange(state, {mobile, countryCode}) {
      state.telNumber = mobile
      state.countryCode = countryCode 
    },
  },
  actions: {

  },
  modules: {
  }
})
